import { render, staticRenderFns } from "./VerificationRecords.vue?vue&type=template&id=16093e10"
import script from "./VerificationRecords.vue?vue&type=script&lang=js"
export * from "./VerificationRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports